import { lockBody, unlockBody } from '../helpers/bodyLock';
let onConfirm;
let onCancel;
const toggleModal = (id, onConfirmCallback, onCancelCallback) => {
    onConfirm = onConfirmCallback;
    onCancel = onCancelCallback;
    const element = document.getElementById(id);
    if (element && !element.classList.contains('hide-modal')) {
        // hide modal
        if (element.classList.contains('show-modal')) {
            element.classList.remove('show-modal');
        }
        element.classList.add('fade-out-modal');
        unlockBody();
        setTimeout(() => {
            element.classList.add('hide-modal');
        }, 320);
    }
    else if (element) {
        // show modal
        element.classList.remove('hide-modal');
        element.classList.remove('fade-out-modal');
        element.classList.add('show-modal');
        lockBody();
    }
};
const closeModal = (modalID) => {
    toggleModal(modalID);
};
const initModal = () => {
    const cancelButtons = document.querySelectorAll('[data-modal-close]');
    cancelButtons.forEach((button) => {
        const modalID = button.dataset.modalClose;
        button.addEventListener('click', () => {
            closeModal(modalID);
        });
    });
};
export { toggleModal, initModal };
